// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%2710%27/%3E%3Cline x1=%2712%27 y1=%2716%27 x2=%2712%27 y2=%2712%27/%3E%3Cline x1=%2712%27 y1=%278%27 x2=%2712.01%27 y2=%278%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bg-beige: #dad4c6;
  --bg-gold: #b97e22;
  --text-dark: #242122;
  --text-light: #f7f4ee;
  --text-cream: #dad4c6;
  --accent: #ba8026;
  --font-main: "Inter", sans-serif;
  --input-radius: 7px;
}

html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  font-family: var(--font-main);
  height: 100%;
  width: 100%;
}

body {
  background-color: var(--bg-beige);
  transition: background-color 0.3s ease;
  color: var(--text-dark);
}

body[data-page=cadastro] {
  background-color: var(--bg-gold);
  color: var(--text-light);
}

body[data-page=completar] .cadastro-label-heading,
body[data-page=completar] .cadastro-event-title,
body[data-page=completar] .cadastro-event-subtitle {
  color: var(--text-dark);
}

#app-main {
  min-height: 100vh;
}

/* ==============================
   SHARED: HEADER + IAC BRAND
   ============================== */
.iac-header {
  padding: 1.75rem 3.2rem 0;
  display: flex;
  align-items: flex-start;
  position: relative;
  z-index: 2;
}

.iac-brand {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  line-height: 1;
}
.iac-brand:hover {
  text-decoration: none;
}

.iac-logo {
  height: 48px;
  width: auto;
  display: block;
}

/* ==============================
   SHARED: PAGE WRAPPER
   ============================== */
.iac-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* ==============================
   SHARED: EVENT TYPOGRAPHY
   ============================== */
.event-title {
  font-size: clamp(2.25rem, 1.4rem + 1.6vw, 3.1rem);
  font-weight: 300;
  line-height: 1.04;
  letter-spacing: -0.03em;
  margin-bottom: 2rem;
}

.event-title strong {
  font-weight: 700;
}

.event-organizer {
  font-size: clamp(1.05rem, 0.85rem + 0.4vw, 1.35rem);
  font-weight: 300;
  line-height: 1.45;
  margin-bottom: 2rem;
}

.event-date {
  font-size: clamp(1.1rem, 0.9rem + 0.5vw, 1.4rem);
  line-height: 1.25;
  margin-bottom: 2rem;
}

.event-date strong {
  font-weight: 700;
}

/* ==============================
   SHARED: CTA BUTTON
   ============================== */
.btn-cta {
  display: inline-block;
  background-color: var(--accent);
  color: var(--text-light);
  padding: 0.9rem 2rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  border: none;
  border-radius: 0;
  transition: opacity 0.2s;
}

.btn-cta:hover {
  opacity: 0.85;
  color: #fff;
  text-decoration: none;
}

.link-agenda {
  display: block;
  margin-top: 1rem;
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--text-dark);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.link-agenda:hover {
  color: var(--accent);
}

/* ==============================
   SHARED: CONVEXAS LOGO
   ============================== */
.convexas-logo {
  width: auto;
  max-width: 100%;
  display: block;
  object-fit: contain;
}

/* ==============================
   HOME PAGE
   ============================== */
.home-main {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(340px, 1fr) minmax(280px, auto);
  align-items: start;
  padding: 0 3.2rem 2rem;
  gap: 2rem;
}

.home-content {
  max-width: 30rem;
  margin-left: clamp(0rem, 7vw, 11rem);
  margin-top: min(14vh, 7rem);
  grid-column: 1;
  grid-row: 1;
}

.home-logo-right {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  min-height: calc(100vh - 5.5rem);
  grid-column: 2;
  grid-row: 1;
}

.home-logo-right .convexas-logo {
  max-height: min(78vh, 44rem);
}

/* ==============================
   CADASTRO PAGE
   ============================== */
.cadastro-main {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(360px, 520px) minmax(300px, auto);
  align-items: center;
  justify-content: center;
  padding: 2rem 3.2rem;
  gap: 3rem 6rem;
}

.cadastro-form-section {
  max-width: 520px;
  width: 100%;
  margin: 0;
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
}

.cadastro-heading {
  margin-bottom: 1.4rem;
}

.cadastro-label-heading {
  font-size: clamp(1.45rem, 0.9rem + 1vw, 2rem);
  font-weight: 300;
  color: var(--text-cream);
  margin: 0 0 0.1rem;
  line-height: 1;
}

.cadastro-event-title {
  font-size: clamp(2.1rem, 1.35rem + 1.2vw, 2.85rem);
  font-weight: 700;
  color: var(--text-cream);
  margin: 0;
  line-height: 1.02;
  letter-spacing: -0.03em;
}

.cadastro-event-subtitle {
  font-size: clamp(1.75rem, 1.15rem + 0.9vw, 2.35rem);
  font-weight: 300;
  color: var(--text-cream);
  line-height: 1.02;
  letter-spacing: -0.03em;
  margin: 0;
}

.cadastro-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 400;
  color: var(--text-dark);
  margin-bottom: 0.2rem;
}

.cadastro-input,
.cadastro-select {
  display: block;
  width: 100%;
  min-height: 1.6rem;
  padding: 0.32rem 0.6rem;
  border: none;
  background-color: #ffffff;
  color: var(--text-dark);
  font-size: 0.8rem;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--input-radius);
  font-family: var(--font-main);
}

.cadastro-select {
  cursor: pointer;
}

.cadastro-input:focus,
.cadastro-select:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
}

/* Form grid: two columns */
.cadastro-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem 1.1rem;
}

.cadastro-form-grid .field-full {
  grid-column: 1/-1;
}

.cadastro-form-grid .field-cep {
  grid-column: 1/2;
  max-width: 55%;
}

.field-inline {
  display: flex;
  gap: 1rem;
}
.field-inline .field-numero {
  flex: 0 0 28%;
}
.field-inline .field-complemento {
  flex: 0 0 28%;
}

.cadastro-submit-row {
  display: flex;
  align-items: flex-start;
  gap: 1.4rem;
  margin-top: 0.8rem;
}

.btn-enviar {
  display: inline-block;
  background-color: var(--text-dark);
  color: var(--text-light);
  padding: 0.8rem 1.9rem;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: var(--font-main);
  flex-shrink: 0;
  align-self: center;
}

.btn-enviar:hover {
  opacity: 0.85;
}

.btn-enviar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.required-note {
  margin-top: 0.25rem;
}
.required-note p {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--text-light);
  margin: 0;
  opacity: 0.85;
}

body[data-page=completar] .required-note p {
  color: var(--text-dark);
}

.lgpd-text {
  font-size: 0.72rem;
  font-weight: 400;
  line-height: 1.35;
  color: var(--text-dark);
  margin: 0;
  max-width: 30rem;
}
.lgpd-text a {
  color: var(--text-dark);
  text-decoration: underline;
}

.cadastro-side-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 0;
  grid-column: 2;
  grid-row: 1;
  align-self: center;
}

.cadastro-side-section .convexas-logo {
  max-height: min(68vh, 38rem);
}

.cadastro-date-bottom {
  font-size: clamp(1.1rem, 0.9rem + 0.5vw, 1.45rem);
  font-weight: 400;
  color: var(--text-dark);
  text-align: right;
  line-height: 1.2;
  margin-top: 1.5rem;
}

.msg-error {
  color: #f8d7da;
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
  display: none;
}

.msg-sucesso {
  display: none;
  padding: 2rem 0;
}
.msg-sucesso h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-cream);
  margin-bottom: 0.75rem;
}
.msg-sucesso p {
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-dark);
  line-height: 1.5;
}

/* ==============================
   LOGIN PAGE
   ============================== */
.login-main {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr);
  align-items: end;
  align-content: center;
  padding: 1rem 3.2rem 18vh;
  gap: 4rem;
}

.login-info-section {
  max-width: 23rem;
  justify-self: end;
  text-align: right;
  grid-column: 1;
  grid-row: 1;
}

.login-logo-center {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  grid-column: 2;
  grid-row: 1;
}

.login-logo-center .convexas-logo {
  max-height: min(55vh, 34rem);
  width: auto;
}

.login-info-section .event-title {
  font-size: clamp(1.55rem, 0.9rem + 1.1vw, 1.9rem);
  margin-bottom: 1.2rem;
}

.login-info-section .event-date {
  font-size: clamp(0.92rem, 0.73rem + 0.36vw, 1.1rem);
  margin-bottom: 0;
}

.login-form-section {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  grid-column: 3;
  grid-row: 1;
}

.login-card {
  width: 100%;
  max-width: 275px;
}
.login-card h2 {
  font-size: clamp(1.55rem, 1.2rem + 0.63vw, 1.95rem);
  line-height: 0.98;
  font-weight: 700;
  margin-bottom: 0.72rem;
  color: var(--text-dark);
  letter-spacing: -0.03em;
}

.login-input {
  display: block;
  width: 100%;
  min-height: 1.58rem;
  padding: 0.44rem 0.69rem;
  border: none;
  background: #fff;
  color: var(--text-dark);
  font-size: 0.86rem;
  margin-bottom: 0.52rem;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--input-radius);
  font-family: var(--font-main);
}
.login-input::placeholder {
  color: #8d877d;
}
.login-input:focus {
  box-shadow: 0 0 0 2px rgba(186, 128, 38, 0.18);
}

.termos-text {
  font-size: 0.72rem;
  color: var(--text-dark);
  margin-bottom: 1rem;
  line-height: 1.3;
}
.termos-text label {
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
}
.termos-text input[type=checkbox] {
  width: 11px;
  height: 11px;
  margin-top: 2px;
  accent-color: var(--accent);
  flex-shrink: 0;
}
.termos-text a {
  color: var(--text-dark);
  text-decoration: underline;
}

.btn-entrar {
  background-color: var(--accent);
  color: var(--text-light);
  padding: 0.75rem 2.1rem;
  font-size: 0.9rem;
  font-weight: 700;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: var(--font-main);
  display: inline-block;
  margin-bottom: 0.675rem;
}
.btn-entrar:hover {
  opacity: 0.85;
}
.btn-entrar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-register-cta {
  font-size: 0.76rem;
  color: var(--text-dark);
  margin-top: 0.6rem;
  margin-bottom: 0;
}
.login-register-cta a {
  color: var(--accent);
  text-decoration: underline;
  font-weight: 600;
}
.login-register-cta a:hover {
  opacity: 0.8;
}

.link-cadastro {
  display: block;
  font-size: 0.8rem;
  color: var(--text-dark);
  text-decoration: none;
  margin-top: 0.5rem;
}
.link-cadastro:hover {
  color: var(--accent);
  text-decoration: underline;
}

.msg-login-error {
  color: #8b0000;
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
  display: none;
  background-color: rgba(255, 220, 220, 0.6);
  padding: 0.5rem 0.75rem;
}

/* ==============================
   LIVE PAGE
   ============================== */
.live-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 2rem;
}

.iframe-container {
  position: relative;
  width: min(100%, 1100px);
  padding-bottom: min(56.25%, 618.75px);
}
.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* ==============================
   AGENDA PAGE
   ============================== */
.agenda-main {
  flex: 1;
  display: grid;
  grid-template-columns: minmax(340px, 1fr) minmax(220px, auto);
  align-items: start;
  padding: 0 3.2rem 4rem;
  gap: 2rem;
}

.agenda-logo-right {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  grid-column: 2;
  grid-row: 1;
}

.agenda-logo-right .convexas-logo {
  max-height: min(78vh, 44rem);
}

.agenda-content {
  grid-column: 1;
  grid-row: 1;
  margin-left: clamp(0rem, 7vw, 11rem);
  margin-top: min(8vh, 4rem);
  max-width: 42rem;
}

.agenda-title {
  font-size: clamp(2.25rem, 1.4rem + 1.6vw, 3.1rem);
  font-weight: 300;
  line-height: 1.04;
  letter-spacing: -0.03em;
  margin-bottom: 0.6rem;
}

.agenda-subtitle {
  font-size: clamp(0.85rem, 0.75rem + 0.2vw, 1rem);
  font-weight: 400;
  color: var(--accent);
  margin-bottom: 2.5rem;
  letter-spacing: 0.01em;
}

.agenda-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.agenda-item {
  display: grid;
  grid-template-columns: 6rem 1fr;
  gap: 0 1.75rem;
  padding: 1.5rem 0;
  border-top: 1px solid var(--text-dark);
}
.agenda-item:last-child {
  border-bottom: 1px solid var(--text-dark);
}

.agenda-item-left {
  padding-top: 0.15rem;
}

.mesa-label {
  font-size: clamp(1rem, 0.85rem + 0.3vw, 1.2rem);
  font-weight: 300;
  color: var(--accent);
  line-height: 1.2;
  white-space: nowrap;
}

.agenda-item-right {
  min-width: 0;
}

.mesa-meta {
  font-size: 0.78rem;
  font-weight: 400;
  color: var(--text-dark);
  opacity: 0.65;
  margin: 0 0 1rem;
  line-height: 1.3;
  letter-spacing: 0.01em;
}

.speaker-entry {
  margin-bottom: 0.9rem;
}
.speaker-entry:last-child {
  margin-bottom: 0;
}

.speaker-name {
  display: inline-block;
  font-family: inherit;
  font-size: clamp(0.95rem, 0.85rem + 0.2vw, 1.05rem);
  font-weight: 700;
  margin: 0 0 0.2rem;
  padding: 0;
  line-height: 1.2;
  color: var(--text-dark);
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: color 0.2s ease;
}
.speaker-name::after {
  content: "";
  display: inline-block;
  width: 0.78em;
  height: 0.78em;
  margin-left: 0.3em;
  vertical-align: -0.06em;
  background-color: currentColor;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/contain no-repeat;
  opacity: 0.55;
  transition: opacity 0.2s ease;
}
.speaker-name:hover, .speaker-name:focus-visible {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 3px;
  outline: none;
}
.speaker-name:hover::after, .speaker-name:focus-visible::after {
  opacity: 1;
}

/* ==============================
   BIO MODAL
   ============================== */
.bio-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.bio-modal[hidden] {
  display: none;
}

.bio-modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(36, 33, 34, 0.55);
  cursor: pointer;
}

.bio-modal-content {
  position: relative;
  background-color: var(--bg-beige);
  color: var(--text-dark);
  max-width: 38rem;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  padding: 2.25rem 2.25rem 2rem;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.bio-modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  color: var(--text-dark);
  font-size: 1.8rem;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.2s ease;
}
.bio-modal-close:hover, .bio-modal-close:focus-visible {
  color: var(--accent);
  outline: none;
}

.bio-modal-name {
  font-size: clamp(1.4rem, 1.05rem + 0.7vw, 1.75rem);
  font-weight: 700;
  margin: 0 0 1rem;
  line-height: 1.15;
  letter-spacing: -0.02em;
  padding-right: 1.5rem;
}

.bio-modal-body p {
  font-size: clamp(0.9rem, 0.82rem + 0.15vw, 1rem);
  font-weight: 400;
  line-height: 1.55;
  margin: 0 0 0.85rem;
}
.bio-modal-body p:last-child {
  margin-bottom: 0;
}

body.bio-modal-open {
  overflow: hidden;
}

.speaker-talk {
  font-size: clamp(0.85rem, 0.78rem + 0.15vw, 0.95rem);
  font-weight: 300;
  margin: 0;
  line-height: 1.45;
  color: var(--text-dark);
}

/* ==============================
   RESPONSIVE — tablet
   ============================== */
@media (max-width: 1024px) {
  .iac-header {
    padding: 1.25rem 2rem 0;
  }
  .home-main,
  .cadastro-main,
  .login-main,
  .agenda-main {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .home-content {
    margin-left: clamp(0rem, 2vw, 3rem);
  }
  .cadastro-form-section {
    margin-left: 0;
  }
  .login-main {
    grid-template-columns: minmax(200px, 1fr) minmax(240px, 1.3fr) minmax(220px, 1fr);
    gap: 1.5rem;
  }
}
/* ==============================
   RESPONSIVE — mobile
   ============================== */
@media (max-width: 768px) {
  .iac-header {
    padding: 1rem 1.25rem 0;
  }
  .iac-logo {
    height: 34px;
  }
  .event-title {
    font-size: 1.75rem;
    margin-bottom: 1.25rem;
  }
  .event-organizer {
    font-size: 1rem;
    line-height: 1.45;
    margin-bottom: 1.5rem;
  }
  .event-date {
    font-size: 1rem;
    line-height: 1.3;
    margin-bottom: 1.25rem;
  }
  /* ==========================
     HOME / ONBOARDING MOBILE
     Convexas logo top-right (tall),
     content vertically+horizontally
     centered in the lower half.
     ========================== */
  .home-main {
    display: block;
    padding: 0 2rem 2rem;
  }
  .home-logo-right {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    min-height: 0;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .home-logo-right .convexas-logo {
    width: auto;
    height: 38vh;
    max-height: 22rem;
  }
  .home-content {
    margin: 34vh auto 0;
    max-width: 22rem;
    padding-left: 0.75rem;
  }
  /* ==========================
     LOGIN MOBILE
     2-col top: info left | convexas right.
     Form below, right-aligned.
     ========================== */
  .login-main {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    padding: 0 1.25rem 2rem;
    gap: 0.5rem 1rem;
    align-items: center;
  }
  .login-info-section {
    grid-column: 1;
    grid-row: 1;
    max-width: 100%;
    justify-self: start;
    text-align: right;
    margin-top: 2.5rem;
  }
  .login-logo-center {
    grid-column: 2;
    grid-row: 1;
    justify-content: flex-end;
    align-items: flex-start;
    display: flex;
    margin-top: 2rem;
  }
  .login-logo-center .convexas-logo {
    width: auto;
    height: 50vh;
    max-height: 28rem;
  }
  .login-form-section {
    grid-column: 1/-1;
    grid-row: 2;
    width: 100%;
    justify-content: flex-end;
    padding-top: 0.5rem;
  }
  .login-card {
    width: 100%;
    max-width: 62%;
  }
  .login-card h2 {
    font-size: 1.6rem;
    margin-bottom: 0.75rem;
  }
  .login-input {
    font-size: 1rem;
    padding: 0.65rem 0.9rem;
  }
  /* ==========================
     CADASTRO MOBILE
     Logo positioning mirrors the
     onboarding screen for a seamless
     transition. Form + heading flow
     below, horizontally centered.
     ========================== */
  .cadastro-main {
    display: block;
    padding: 0 1.5rem 2rem 0.5rem;
  }
  .cadastro-side-section {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    width: auto;
    max-width: none;
    min-height: 0;
    padding-top: 0;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    z-index: 1;
    pointer-events: none;
  }
  .cadastro-side-section .convexas-logo {
    width: auto;
    height: 38vh;
    max-height: 22rem;
  }
  .cadastro-date-bottom {
    display: none;
  }
  .cadastro-form-section {
    margin-top: max(4rem, 32vh - 2.5rem);
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0.65rem;
    width: 100%;
    max-width: 21rem;
    padding-left: 0;
    padding-right: 0.5rem;
    position: relative;
    z-index: 2;
    justify-self: start;
  }
  /* Heading sits beside the Convexas logo.
     The form-grid that follows is full-width and its
     top rows overlap the bottom of the logo — form-section
     has z-index 2 so inputs render above the logo. */
  .cadastro-heading {
    max-width: 55%;
    margin-bottom: 0.6rem;
  }
  .cadastro-label-heading {
    font-size: 1.4rem;
  }
  .cadastro-event-title {
    font-size: 1.8rem;
  }
  .cadastro-event-subtitle {
    font-size: 1.55rem;
  }
  /* Mobile form: 12-col grid with explicit placement + order */
  .cadastro-form-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 0.55rem 0.8rem;
  }
  /* Full-width rows */
  .cadastro-form-grid .field-nome,
  .cadastro-form-grid .field-email,
  .cadastro-form-grid .field-endereco {
    grid-column: 1/-1;
    max-width: none;
  }
  /* Número + Complemento: narrower left block */
  .cadastro-form-grid .field-numero-complemento {
    grid-column: 1/9;
    max-width: none;
  }
  .field-inline .field-numero {
    flex: 0 0 38%;
  }
  .field-inline .field-complemento {
    flex: 0 0 52%;
  }
  /* Cidade narrow, Estado wider, side-by-side */
  .cadastro-form-grid .field-cidade {
    grid-column: 1/6;
  }
  .cadastro-form-grid .field-estado {
    grid-column: 6/12;
  }
  /* CEP narrow, left only */
  .cadastro-form-grid .field-cep {
    grid-column: 1/6;
    max-width: none;
  }
  /* Telefone + Formação pushed to bottom, narrow */
  .cadastro-form-grid .field-telefone {
    grid-column: 1/6;
    order: 10;
  }
  .cadastro-form-grid .field-formacao {
    grid-column: 1/8;
    order: 11;
  }
  .cadastro-submit-row {
    grid-column: 1/-1;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin-top: 0.5rem;
    order: 20;
  }
  .btn-enviar {
    align-self: flex-start;
    padding: 0.85rem 1.8rem;
  }
  .lgpd-text {
    max-width: none;
    font-size: 0.75rem;
  }
  /* ---- Live ---- */
  .live-main {
    padding: 0.5rem 1rem 2rem;
  }
  .live-with-questions {
    flex-direction: column;
  }
  .live-video-wrap {
    width: 100%;
  }
  .live-sidebar {
    flex: none;
    width: 100%;
  }
  /* ---- Agenda ---- */
  .agenda-main {
    display: block;
    padding: 0 1.5rem 3rem;
  }
  .agenda-logo-right {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    z-index: 1;
  }
  .agenda-logo-right .convexas-logo {
    width: auto;
    height: 32vh;
    max-height: 18rem;
  }
  .agenda-content {
    margin: calc(32vh + 1.5rem) 0 0;
    max-width: none;
  }
  .agenda-item {
    grid-template-columns: 5rem 1fr;
    gap: 0 1rem;
  }
  .bio-modal {
    padding: 1rem;
    align-items: flex-end;
  }
  .bio-modal-content {
    padding: 2rem 1.25rem 1.5rem;
    max-height: 90vh;
  }
}
/* ==============================
   RESPONSIVE — small mobile (<480px)
   ============================== */
@media (max-width: 480px) {
  .iac-logo {
    height: 28px;
  }
  .login-card {
    max-width: 70%;
  }
  .home-content {
    margin-top: 40vh;
    max-width: 20rem;
  }
  .cadastro-heading {
    max-width: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/iac/styles/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;AAEJ;;AACA;EACI,iCAAA;EACA,sCAAA;EACA,uBAAA;AAEJ;;AACA;EACI,gCAAA;EACA,wBAAA;AAEJ;;AAEI;;;EAGI,uBAAA;AACR;;AAGA;EACI,iBAAA;AAAJ;;AAGA;;mCAAA;AAGA;EACI,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAAJ;AAEI;EACI,qBAAA;AAAR;;AAIA;EACI,YAAA;EACA,WAAA;EACA,cAAA;AADJ;;AAIA;;mCAAA;AAGA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AADJ;;AAIA;;mCAAA;AAGA;EACI,iDAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,mDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,gDAAA;EACA,iBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;;mCAAA;AAGA;EACI,qBAAA;EACA,+BAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AADJ;;AAIA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;AADJ;;AAIA;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AADJ;AAGI;EACI,oBAAA;AADR;;AAKA;;mCAAA;AAGA;EACI,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAFJ;;AAKA;;mCAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,oCAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;AAFJ;;AAKA;EACI,4BAAA;AAFJ;;AAKA;;mCAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,+DAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,6CAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,kDAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,mDAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAFJ;;AAKA;;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,6BAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;;EAEI,2CAAA;AAFJ;;AAKA,2BAAA;AACA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,SAAA;AAFJ;AAII;EACI,aAAA;AAFR;AAKI;EACI,aAAA;AAHR;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,kCAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,YAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;AAMI;EACI,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,aAAA;AAJR;;AAQA;EACI,uBAAA;AALJ;;AAQA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AALJ;AAOI;EACI,uBAAA;EACA,0BAAA;AALR;;AASA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AANJ;;AASA;EACI,4BAAA;AANJ;;AASA;EACI,iDAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;;AASA;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;AANJ;;AASA;EACI,aAAA;EACA,eAAA;AANJ;AAQI;EACI,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;AANR;AASI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAPR;;AAWA;;mCAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,iEAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;AARJ;;AAWA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AARJ;;AAWA;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;AARJ;;AAWA;EACI,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,iDAAA;EACA,qBAAA;AARJ;;AAWA;EACI,mDAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;AARJ;;AAWA;EACI,WAAA;EACA,gBAAA;AARJ;AAUI;EACI,mDAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AARR;;AAYA;EACI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,6BAAA;AATJ;AAWI;EACI,cAAA;AATR;AAYI;EACI,8CAAA;AAVR;;AAcA;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;AAaI;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAXR;AAcI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;AAZR;AAeI;EACI,uBAAA;EACA,0BAAA;AAbR;;AAiBA;EACI,+BAAA;EACA,wBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;AAdJ;AAgBI;EACI,aAAA;AAdR;AAiBI;EACI,YAAA;EACA,mBAAA;AAfR;;AAmBA;EACI,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAhBJ;AAkBI;EACI,oBAAA;EACA,0BAAA;EACA,gBAAA;AAhBR;AAkBQ;EACI,YAAA;AAhBZ;;AAqBA;EACI,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACI,oBAAA;EACA,0BAAA;AAlBR;;AAsBA;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,0CAAA;EACA,uBAAA;AAnBJ;;AAsBA;;mCAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAnBJ;;AAsBA;EACI,kBAAA;EACA,wBAAA;EACA,qCAAA;AAnBJ;AAqBI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAnBR;;AAuBA;;mCAAA;AAGA;EACI,OAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AApBJ;;AAuBA;EACI,4BAAA;AApBJ;;AAuBA;EACI,cAAA;EACA,WAAA;EACA,oCAAA;EACA,0BAAA;EACA,gBAAA;AApBJ;;AAuBA;EACI,iDAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;AApBJ;;AAuBA;EACI,gDAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,+BAAA;EACA,cAAA;EACA,iBAAA;EACA,sCAAA;AApBJ;AAsBI;EACI,yCAAA;AApBR;;AAwBA;EACI,oBAAA;AArBJ;;AAwBA;EACI,+CAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AArBJ;;AAwBA;EACI,YAAA;AArBJ;;AAwBA;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AArBJ;;AAwBA;EACI,qBAAA;AArBJ;AAuBI;EACI,gBAAA;AArBR;;AAyBA;EACI,qBAAA;EACA,oBAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAtBJ;AAwBI;EACI,WAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8EAAA;EACA,sEAAA;EACA,aAAA;EACA,6BAAA;AAtBR;AAyBI;EAEI,oBAAA;EACA,0BAAA;EACA,0BAAA;EACA,aAAA;AAxBR;AA2BI;EAEI,UAAA;AA1BR;;AA8BA;;mCAAA;AAGA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3BJ;;AA8BA;EACI,aAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,QAAA;EACA,wCAAA;EACA,eAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,iCAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,2CAAA;EACA,kBAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;AA3BJ;AA6BI;EAEI,oBAAA;EACA,aAAA;AA5BR;;AAgCA;EACI,kDAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;AA7BJ;;AAgCA;EACI,gDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA7BJ;AA+BI;EACI,gBAAA;AA7BR;;AAiCA;EACI,gBAAA;AA9BJ;;AAiCA;EACI,oDAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AA9BJ;;AAiCA;;mCAAA;AAGA;EACI;IACI,uBAAA;EA9BN;EAiCE;;;;IAII,kBAAA;IACA,mBAAA;EA/BN;EAkCE;IACI,mCAAA;EAhCN;EAmCE;IACI,cAAA;EAjCN;EAoCE;IACI,iFAAA;IACA,WAAA;EAlCN;AACF;AAqCA;;mCAAA;AAGA;EACI;IACI,uBAAA;EAnCN;EAsCE;IACI,YAAA;EApCN;EAuCE;IACI,kBAAA;IACA,sBAAA;EArCN;EAwCE;IACI,eAAA;IACA,iBAAA;IACA,qBAAA;EAtCN;EAyCE;IACI,eAAA;IACA,gBAAA;IACA,sBAAA;EAvCN;EA0CE;;;;;iCAAA;EAMA;IACI,cAAA;IACA,oBAAA;EAxCN;EA2CE;IACI,kBAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,UAAA;IACA,aAAA;IACA,yBAAA;IACA,uBAAA;EAzCN;EA4CE;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EA1CN;EA6CE;IACI,mBAAA;IACA,gBAAA;IACA,qBAAA;EA3CN;EA8CE;;;;iCAAA;EAKA;IACI,aAAA;IACA,8BAAA;IACA,6BAAA;IACA,uBAAA;IACA,gBAAA;IACA,mBAAA;EA5CN;EA+CE;IACI,cAAA;IACA,WAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EA7CN;EAgDE;IACI,cAAA;IACA,WAAA;IACA,yBAAA;IACA,uBAAA;IACA,aAAA;IACA,gBAAA;EA9CN;EAiDE;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EA/CN;EAkDE;IACI,iBAAA;IACA,WAAA;IACA,WAAA;IACA,yBAAA;IACA,mBAAA;EAhDN;EAmDE;IACI,WAAA;IACA,cAAA;EAjDN;EAmDM;IACI,iBAAA;IACA,sBAAA;EAjDV;EAqDE;IACI,eAAA;IACA,uBAAA;EAnDN;EAsDE;;;;;;iCAAA;EAOA;IACI,cAAA;IACA,6BAAA;EApDN;EAuDE;IACI,kBAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,eAAA;IACA,aAAA;IACA,cAAA;IACA,mBAAA;IACA,yBAAA;IACA,qBAAA;IACA,UAAA;IACA,oBAAA;EArDN;EAwDE;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EAtDN;EAyDE;IACI,aAAA;EAvDN;EA0DE;IACI,oCAAA;IACA,eAAA;IACA,gBAAA;IACA,oBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;EAxDN;EA2DE;;;qDAAA;EAIA;IACI,cAAA;IACA,qBAAA;EAzDN;EA4DE;IACI,iBAAA;EA1DN;EA6DE;IACI,iBAAA;EA3DN;EA8DE;IACI,kBAAA;EA5DN;EA+DE,6DAAA;EACA;IACI,aAAA;IACA,sCAAA;IACA,mBAAA;EA7DN;EAgEE,oBAAA;EACA;;;IAGI,iBAAA;IACA,eAAA;EA9DN;EAiEE,8CAAA;EACA;IACI,gBAAA;IACA,eAAA;EA/DN;EAmEM;IACI,aAAA;EAjEV;EAmEM;IACI,aAAA;EAjEV;EAqEE,8CAAA;EACA;IACI,gBAAA;EAnEN;EAsEE;IACI,iBAAA;EApEN;EAuEE,0BAAA;EACA;IACI,gBAAA;IACA,eAAA;EArEN;EAwEE,iDAAA;EACA;IACI,gBAAA;IACA,SAAA;EAtEN;EAyEE;IACI,gBAAA;IACA,SAAA;EAvEN;EA0EE;IACI,iBAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;IACA,SAAA;EAxEN;EA2EE;IACI,sBAAA;IACA,uBAAA;EAzEN;EA4EE;IACI,eAAA;IACA,kBAAA;EA1EN;EA6EE,mBAAA;EACA;IACI,yBAAA;EA3EN;EA8EE;IACI,sBAAA;EA5EN;EA+EE;IACI,WAAA;EA7EN;EAgFE;IACI,UAAA;IACA,WAAA;EA9EN;EAiFE,qBAAA;EACA;IACI,cAAA;IACA,sBAAA;EA/EN;EAkFE;IACI,kBAAA;IACA,SAAA;IACA,aAAA;IACA,UAAA;EAhFN;EAmFE;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EAjFN;EAoFE;IACI,+BAAA;IACA,eAAA;EAlFN;EAqFE;IACI,+BAAA;IACA,WAAA;EAnFN;EAsFE;IACI,aAAA;IACA,qBAAA;EApFN;EAuFE;IACI,4BAAA;IACA,gBAAA;EArFN;AACF;AAwFA;;mCAAA;AAGA;EACI;IACI,YAAA;EAtFN;EAyFE;IACI,cAAA;EAvFN;EA0FE;IACI,gBAAA;IACA,gBAAA;EAxFN;EA2FE;IACI,cAAA;EAzFN;AACF","sourcesContent":[":root {\n    --bg-beige: #dad4c6;\n    --bg-gold: #b97e22;\n    --text-dark: #242122;\n    --text-light: #f7f4ee;\n    --text-cream: #dad4c6;\n    --accent: #ba8026;\n    --font-main: 'Inter', sans-serif;\n    --input-radius: 7px;\n}\n\nhtml, body {\n    overflow-x: hidden;\n    margin: 0;\n    padding: 0;\n    font-family: var(--font-main);\n    height: 100%;\n    width: 100%;\n}\n\nbody {\n    background-color: var(--bg-beige);\n    transition: background-color 0.3s ease;\n    color: var(--text-dark);\n}\n\nbody[data-page=\"cadastro\"] {\n    background-color: var(--bg-gold);\n    color: var(--text-light);\n}\n\nbody[data-page=\"completar\"] {\n    .cadastro-label-heading,\n    .cadastro-event-title,\n    .cadastro-event-subtitle {\n        color: var(--text-dark);\n    }\n}\n\n#app-main {\n    min-height: 100vh;\n}\n\n/* ==============================\n   SHARED: HEADER + IAC BRAND\n   ============================== */\n.iac-header {\n    padding: 1.75rem 3.2rem 0;\n    display: flex;\n    align-items: flex-start;\n    position: relative;\n    z-index: 2;\n}\n\n.iac-brand {\n    display: inline-flex;\n    align-items: center;\n    text-decoration: none;\n    line-height: 1;\n\n    &:hover {\n        text-decoration: none;\n    }\n}\n\n.iac-logo {\n    height: 48px;\n    width: auto;\n    display: block;\n}\n\n/* ==============================\n   SHARED: PAGE WRAPPER\n   ============================== */\n.iac-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n/* ==============================\n   SHARED: EVENT TYPOGRAPHY\n   ============================== */\n.event-title {\n    font-size: clamp(2.25rem, 1.4rem + 1.6vw, 3.1rem);\n    font-weight: 300;\n    line-height: 1.04;\n    letter-spacing: -0.03em;\n    margin-bottom: 2rem;\n}\n\n.event-title strong {\n    font-weight: 700;\n}\n\n.event-organizer {\n    font-size: clamp(1.05rem, 0.85rem + 0.4vw, 1.35rem);\n    font-weight: 300;\n    line-height: 1.45;\n    margin-bottom: 2rem;\n}\n\n.event-date {\n    font-size: clamp(1.1rem, 0.9rem + 0.5vw, 1.4rem);\n    line-height: 1.25;\n    margin-bottom: 2rem;\n}\n\n.event-date strong {\n    font-weight: 700;\n}\n\n/* ==============================\n   SHARED: CTA BUTTON\n   ============================== */\n.btn-cta {\n    display: inline-block;\n    background-color: var(--accent);\n    color: var(--text-light);\n    padding: 0.9rem 2rem;\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1;\n    text-decoration: none;\n    cursor: pointer;\n    border: none;\n    border-radius: 0;\n    transition: opacity 0.2s;\n}\n\n.btn-cta:hover {\n    opacity: 0.85;\n    color: #fff;\n    text-decoration: none;\n}\n\n.link-agenda {\n    display: block;\n    margin-top: 1rem;\n    font-size: 0.85rem;\n    font-weight: 400;\n    color: var(--text-dark);\n    text-decoration: underline;\n    text-underline-offset: 3px;\n    cursor: pointer;\n\n    &:hover {\n        color: var(--accent);\n    }\n}\n\n/* ==============================\n   SHARED: CONVEXAS LOGO\n   ============================== */\n.convexas-logo {\n    width: auto;\n    max-width: 100%;\n    display: block;\n    object-fit: contain;\n}\n\n/* ==============================\n   HOME PAGE\n   ============================== */\n.home-main {\n    flex: 1;\n    display: grid;\n    grid-template-columns: minmax(340px, 1fr) minmax(280px, auto);\n    align-items: start;\n    padding: 0 3.2rem 2rem;\n    gap: 2rem;\n}\n\n.home-content {\n    max-width: 30rem;\n    margin-left: clamp(0rem, 7vw, 11rem);\n    margin-top: min(14vh, 7rem);\n    grid-column: 1;\n    grid-row: 1;\n}\n\n.home-logo-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    min-height: calc(100vh - 5.5rem);\n    grid-column: 2;\n    grid-row: 1;\n}\n\n.home-logo-right .convexas-logo {\n    max-height: min(78vh, 44rem);\n}\n\n/* ==============================\n   CADASTRO PAGE\n   ============================== */\n.cadastro-main {\n    flex: 1;\n    display: grid;\n    grid-template-columns: minmax(360px, 520px) minmax(300px, auto);\n    align-items: center;\n    justify-content: center;\n    padding: 2rem 3.2rem;\n    gap: 3rem 6rem;\n}\n\n.cadastro-form-section {\n    max-width: 520px;\n    width: 100%;\n    margin: 0;\n    grid-column: 1;\n    grid-row: 1;\n    justify-self: end;\n}\n\n.cadastro-heading {\n    margin-bottom: 1.4rem;\n}\n\n.cadastro-label-heading {\n    font-size: clamp(1.45rem, 0.9rem + 1vw, 2rem);\n    font-weight: 300;\n    color: var(--text-cream);\n    margin: 0 0 0.1rem;\n    line-height: 1;\n}\n\n.cadastro-event-title {\n    font-size: clamp(2.1rem, 1.35rem + 1.2vw, 2.85rem);\n    font-weight: 700;\n    color: var(--text-cream);\n    margin: 0;\n    line-height: 1.02;\n    letter-spacing: -0.03em;\n}\n\n.cadastro-event-subtitle {\n    font-size: clamp(1.75rem, 1.15rem + 0.9vw, 2.35rem);\n    font-weight: 300;\n    color: var(--text-cream);\n    line-height: 1.02;\n    letter-spacing: -0.03em;\n    margin: 0;\n}\n\n.cadastro-label {\n    display: block;\n    font-size: 0.72rem;\n    font-weight: 400;\n    color: var(--text-dark);\n    margin-bottom: 0.2rem;\n}\n\n.cadastro-input,\n.cadastro-select {\n    display: block;\n    width: 100%;\n    min-height: 1.6rem;\n    padding: 0.32rem 0.6rem;\n    border: none;\n    background-color: #ffffff;\n    color: var(--text-dark);\n    font-size: 0.8rem;\n    box-sizing: border-box;\n    outline: none;\n    border-radius: var(--input-radius);\n    font-family: var(--font-main);\n}\n\n.cadastro-select {\n    cursor: pointer;\n}\n\n.cadastro-input:focus,\n.cadastro-select:focus {\n    outline: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n/* Form grid: two columns */\n.cadastro-form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.6rem 1.1rem;\n}\n\n.cadastro-form-grid .field-full {\n    grid-column: 1 / -1;\n}\n\n.cadastro-form-grid .field-cep {\n    grid-column: 1 / 2;\n    max-width: 55%;\n}\n\n.field-inline {\n    display: flex;\n    gap: 1rem;\n\n    .field-numero {\n        flex: 0 0 28%;\n    }\n\n    .field-complemento {\n        flex: 0 0 28%;\n    }\n}\n\n.cadastro-submit-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 1.4rem;\n    margin-top: 0.8rem;\n}\n\n.btn-enviar {\n    display: inline-block;\n    background-color: var(--text-dark);\n    color: var(--text-light);\n    padding: 0.8rem 1.9rem;\n    font-size: 0.9rem;\n    font-weight: 700;\n    line-height: 1;\n    border: none;\n    border-radius: 0;\n    cursor: pointer;\n    transition: opacity 0.2s;\n    font-family: var(--font-main);\n    flex-shrink: 0;\n    align-self: center;\n}\n\n.btn-enviar:hover {\n    opacity: 0.85;\n}\n\n.btn-enviar:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.required-note {\n    margin-top: 0.25rem;\n\n    p {\n        font-size: 0.75rem;\n        font-weight: 400;\n        color: var(--text-light);\n        margin: 0;\n        opacity: 0.85;\n    }\n}\n\nbody[data-page=\"completar\"] .required-note p {\n    color: var(--text-dark);\n}\n\n.lgpd-text {\n    font-size: 0.72rem;\n    font-weight: 400;\n    line-height: 1.35;\n    color: var(--text-dark);\n    margin: 0;\n    max-width: 30rem;\n\n    a {\n        color: var(--text-dark);\n        text-decoration: underline;\n    }\n}\n\n.cadastro-side-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    min-width: 0;\n    grid-column: 2;\n    grid-row: 1;\n    align-self: center;\n}\n\n.cadastro-side-section .convexas-logo {\n    max-height: min(68vh, 38rem);\n}\n\n.cadastro-date-bottom {\n    font-size: clamp(1.1rem, 0.9rem + 0.5vw, 1.45rem);\n    font-weight: 400;\n    color: var(--text-dark);\n    text-align: right;\n    line-height: 1.2;\n    margin-top: 1.5rem;\n}\n\n.msg-error {\n    color: #f8d7da;\n    font-size: 0.85rem;\n    margin-bottom: 0.75rem;\n    display: none;\n}\n\n.msg-sucesso {\n    display: none;\n    padding: 2rem 0;\n\n    h2 {\n        font-size: 1.8rem;\n        font-weight: 700;\n        color: var(--text-cream);\n        margin-bottom: 0.75rem;\n    }\n\n    p {\n        font-size: 1rem;\n        font-weight: 400;\n        color: var(--text-dark);\n        line-height: 1.5;\n    }\n}\n\n/* ==============================\n   LOGIN PAGE\n   ============================== */\n.login-main {\n    flex: 1;\n    display: grid;\n    grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr);\n    align-items: end;\n    align-content: center;\n    padding: 1rem 3.2rem 18vh;\n    gap: 4rem;\n}\n\n.login-info-section {\n    max-width: 23rem;\n    justify-self: end;\n    text-align: right;\n    grid-column: 1;\n    grid-row: 1;\n}\n\n.login-logo-center {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    grid-column: 2;\n    grid-row: 1;\n}\n\n.login-logo-center .convexas-logo {\n    max-height: min(55vh, 34rem);\n    width: auto;\n}\n\n.login-info-section .event-title {\n    font-size: clamp(1.55rem, 0.9rem + 1.1vw, 1.9rem);\n    margin-bottom: 1.2rem;\n}\n\n.login-info-section .event-date {\n    font-size: clamp(0.92rem, 0.73rem + 0.36vw, 1.1rem);\n    margin-bottom: 0;\n}\n\n.login-form-section {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-end;\n    grid-column: 3;\n    grid-row: 1;\n}\n\n.login-card {\n    width: 100%;\n    max-width: 275px;\n\n    h2 {\n        font-size: clamp(1.55rem, 1.2rem + 0.63vw, 1.95rem);\n        line-height: 0.98;\n        font-weight: 700;\n        margin-bottom: 0.72rem;\n        color: var(--text-dark);\n        letter-spacing: -0.03em;\n    }\n}\n\n.login-input {\n    display: block;\n    width: 100%;\n    min-height: 1.58rem;\n    padding: 0.44rem 0.69rem;\n    border: none;\n    background: #fff;\n    color: var(--text-dark);\n    font-size: 0.86rem;\n    margin-bottom: 0.52rem;\n    box-sizing: border-box;\n    outline: none;\n    border-radius: var(--input-radius);\n    font-family: var(--font-main);\n\n    &::placeholder {\n        color: #8d877d;\n    }\n\n    &:focus {\n        box-shadow: 0 0 0 2px rgba(186, 128, 38, 0.18);\n    }\n}\n\n.termos-text {\n    font-size: 0.72rem;\n    color: var(--text-dark);\n    margin-bottom: 1rem;\n    line-height: 1.3;\n\n    label {\n        cursor: pointer;\n        display: flex;\n        align-items: flex-start;\n        gap: 0.4rem;\n    }\n\n    input[type=\"checkbox\"] {\n        width: 11px;\n        height: 11px;\n        margin-top: 2px;\n        accent-color: var(--accent);\n        flex-shrink: 0;\n    }\n\n    a {\n        color: var(--text-dark);\n        text-decoration: underline;\n    }\n}\n\n.btn-entrar {\n    background-color: var(--accent);\n    color: var(--text-light);\n    padding: 0.75rem 2.1rem;\n    font-size: 0.9rem;\n    font-weight: 700;\n    border: none;\n    border-radius: 0;\n    cursor: pointer;\n    transition: opacity 0.2s;\n    font-family: var(--font-main);\n    display: inline-block;\n    margin-bottom: 0.675rem;\n\n    &:hover {\n        opacity: 0.85;\n    }\n\n    &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n    }\n}\n\n.login-register-cta {\n    font-size: 0.76rem;\n    color: var(--text-dark);\n    margin-top: 0.6rem;\n    margin-bottom: 0;\n\n    a {\n        color: var(--accent);\n        text-decoration: underline;\n        font-weight: 600;\n\n        &:hover {\n            opacity: 0.8;\n        }\n    }\n}\n\n.link-cadastro {\n    display: block;\n    font-size: 0.8rem;\n    color: var(--text-dark);\n    text-decoration: none;\n    margin-top: 0.5rem;\n\n    &:hover {\n        color: var(--accent);\n        text-decoration: underline;\n    }\n}\n\n.msg-login-error {\n    color: #8b0000;\n    font-size: 0.85rem;\n    margin-bottom: 0.75rem;\n    display: none;\n    background-color: rgba(255, 220, 220, 0.6);\n    padding: 0.5rem 0.75rem;\n}\n\n/* ==============================\n   LIVE PAGE\n   ============================== */\n.live-main {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem 2rem;\n}\n\n.iframe-container {\n    position: relative;\n    width: min(100%, 1100px);\n    padding-bottom: min(56.25%, calc(1100px * 0.5625));\n\n    iframe {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border: none;\n    }\n}\n\n/* ==============================\n   AGENDA PAGE\n   ============================== */\n.agenda-main {\n    flex: 1;\n    display: grid;\n    grid-template-columns: minmax(340px, 1fr) minmax(220px, auto);\n    align-items: start;\n    padding: 0 3.2rem 4rem;\n    gap: 2rem;\n}\n\n.agenda-logo-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    grid-column: 2;\n    grid-row: 1;\n}\n\n.agenda-logo-right .convexas-logo {\n    max-height: min(78vh, 44rem);\n}\n\n.agenda-content {\n    grid-column: 1;\n    grid-row: 1;\n    margin-left: clamp(0rem, 7vw, 11rem);\n    margin-top: min(8vh, 4rem);\n    max-width: 42rem;\n}\n\n.agenda-title {\n    font-size: clamp(2.25rem, 1.4rem + 1.6vw, 3.1rem);\n    font-weight: 300;\n    line-height: 1.04;\n    letter-spacing: -0.03em;\n    margin-bottom: 0.6rem;\n}\n\n.agenda-subtitle {\n    font-size: clamp(0.85rem, 0.75rem + 0.2vw, 1rem);\n    font-weight: 400;\n    color: var(--accent);\n    margin-bottom: 2.5rem;\n    letter-spacing: 0.01em;\n}\n\n.agenda-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.agenda-item {\n    display: grid;\n    grid-template-columns: 6rem 1fr;\n    gap: 0 1.75rem;\n    padding: 1.5rem 0;\n    border-top: 1px solid var(--text-dark);\n\n    &:last-child {\n        border-bottom: 1px solid var(--text-dark);\n    }\n}\n\n.agenda-item-left {\n    padding-top: 0.15rem;\n}\n\n.mesa-label {\n    font-size: clamp(1rem, 0.85rem + 0.3vw, 1.2rem);\n    font-weight: 300;\n    color: var(--accent);\n    line-height: 1.2;\n    white-space: nowrap;\n}\n\n.agenda-item-right {\n    min-width: 0;\n}\n\n.mesa-meta {\n    font-size: 0.78rem;\n    font-weight: 400;\n    color: var(--text-dark);\n    opacity: 0.65;\n    margin: 0 0 1rem;\n    line-height: 1.3;\n    letter-spacing: 0.01em;\n}\n\n.speaker-entry {\n    margin-bottom: 0.9rem;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.speaker-name {\n    display: inline-block;\n    font-family: inherit;\n    font-size: clamp(0.95rem, 0.85rem + 0.2vw, 1.05rem);\n    font-weight: 700;\n    margin: 0 0 0.2rem;\n    padding: 0;\n    line-height: 1.2;\n    color: var(--text-dark);\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    transition: color 0.2s ease;\n\n    &::after {\n        content: \"\";\n        display: inline-block;\n        width: 0.78em;\n        height: 0.78em;\n        margin-left: 0.3em;\n        vertical-align: -0.06em;\n        background-color: currentColor;\n        -webkit-mask: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cline x1='12' y1='16' x2='12' y2='12'/%3E%3Cline x1='12' y1='8' x2='12.01' y2='8'/%3E%3C/svg%3E\") center / contain no-repeat;\n        mask: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cline x1='12' y1='16' x2='12' y2='12'/%3E%3Cline x1='12' y1='8' x2='12.01' y2='8'/%3E%3C/svg%3E\") center / contain no-repeat;\n        opacity: 0.55;\n        transition: opacity 0.2s ease;\n    }\n\n    &:hover,\n    &:focus-visible {\n        color: var(--accent);\n        text-decoration: underline;\n        text-underline-offset: 3px;\n        outline: none;\n    }\n\n    &:hover::after,\n    &:focus-visible::after {\n        opacity: 1;\n    }\n}\n\n/* ==============================\n   BIO MODAL\n   ============================== */\n.bio-modal {\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem;\n}\n\n.bio-modal[hidden] {\n    display: none;\n}\n\n.bio-modal-backdrop {\n    position: absolute;\n    inset: 0;\n    background-color: rgba(36, 33, 34, 0.55);\n    cursor: pointer;\n}\n\n.bio-modal-content {\n    position: relative;\n    background-color: var(--bg-beige);\n    color: var(--text-dark);\n    max-width: 38rem;\n    width: 100%;\n    max-height: 85vh;\n    overflow-y: auto;\n    padding: 2.25rem 2.25rem 2rem;\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n    border-radius: 4px;\n}\n\n.bio-modal-close {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.75rem;\n    background: none;\n    border: none;\n    color: var(--text-dark);\n    font-size: 1.8rem;\n    line-height: 1;\n    padding: 0.25rem 0.5rem;\n    cursor: pointer;\n    font-family: inherit;\n    transition: color 0.2s ease;\n\n    &:hover,\n    &:focus-visible {\n        color: var(--accent);\n        outline: none;\n    }\n}\n\n.bio-modal-name {\n    font-size: clamp(1.4rem, 1.05rem + 0.7vw, 1.75rem);\n    font-weight: 700;\n    margin: 0 0 1rem;\n    line-height: 1.15;\n    letter-spacing: -0.02em;\n    padding-right: 1.5rem;\n}\n\n.bio-modal-body p {\n    font-size: clamp(0.9rem, 0.82rem + 0.15vw, 1rem);\n    font-weight: 400;\n    line-height: 1.55;\n    margin: 0 0 0.85rem;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\nbody.bio-modal-open {\n    overflow: hidden;\n}\n\n.speaker-talk {\n    font-size: clamp(0.85rem, 0.78rem + 0.15vw, 0.95rem);\n    font-weight: 300;\n    margin: 0;\n    line-height: 1.45;\n    color: var(--text-dark);\n}\n\n/* ==============================\n   RESPONSIVE — tablet\n   ============================== */\n@media (max-width: 1024px) {\n    .iac-header {\n        padding: 1.25rem 2rem 0;\n    }\n\n    .home-main,\n    .cadastro-main,\n    .login-main,\n    .agenda-main {\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n\n    .home-content {\n        margin-left: clamp(0rem, 2vw, 3rem);\n    }\n\n    .cadastro-form-section {\n        margin-left: 0;\n    }\n\n    .login-main {\n        grid-template-columns: minmax(200px, 1fr) minmax(240px, 1.3fr) minmax(220px, 1fr);\n        gap: 1.5rem;\n    }\n}\n\n/* ==============================\n   RESPONSIVE — mobile\n   ============================== */\n@media (max-width: 768px) {\n    .iac-header {\n        padding: 1rem 1.25rem 0;\n    }\n\n    .iac-logo {\n        height: 34px;\n    }\n\n    .event-title {\n        font-size: 1.75rem;\n        margin-bottom: 1.25rem;\n    }\n\n    .event-organizer {\n        font-size: 1rem;\n        line-height: 1.45;\n        margin-bottom: 1.5rem;\n    }\n\n    .event-date {\n        font-size: 1rem;\n        line-height: 1.3;\n        margin-bottom: 1.25rem;\n    }\n\n    /* ==========================\n       HOME / ONBOARDING MOBILE\n       Convexas logo top-right (tall),\n       content vertically+horizontally\n       centered in the lower half.\n       ========================== */\n    .home-main {\n        display: block;\n        padding: 0 2rem 2rem;\n    }\n\n    .home-logo-right {\n        position: absolute;\n        top: 1rem;\n        right: 1.5rem;\n        min-height: 0;\n        z-index: 1;\n        display: flex;\n        justify-content: flex-end;\n        align-items: flex-start;\n    }\n\n    .home-logo-right .convexas-logo {\n        width: auto;\n        height: 38vh;\n        max-height: 22rem;\n    }\n\n    .home-content {\n        margin: 34vh auto 0;\n        max-width: 22rem;\n        padding-left: 0.75rem;\n    }\n\n    /* ==========================\n       LOGIN MOBILE\n       2-col top: info left | convexas right.\n       Form below, right-aligned.\n       ========================== */\n    .login-main {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-template-rows: auto auto;\n        padding: 0 1.25rem 2rem;\n        gap: 0.5rem 1rem;\n        align-items: center;\n    }\n\n    .login-info-section {\n        grid-column: 1;\n        grid-row: 1;\n        max-width: 100%;\n        justify-self: start;\n        text-align: right;\n        margin-top: 2.5rem;\n    }\n\n    .login-logo-center {\n        grid-column: 2;\n        grid-row: 1;\n        justify-content: flex-end;\n        align-items: flex-start;\n        display: flex;\n        margin-top: 2rem;\n    }\n\n    .login-logo-center .convexas-logo {\n        width: auto;\n        height: 50vh;\n        max-height: 28rem;\n    }\n\n    .login-form-section {\n        grid-column: 1 / -1;\n        grid-row: 2;\n        width: 100%;\n        justify-content: flex-end;\n        padding-top: 0.5rem;\n    }\n\n    .login-card {\n        width: 100%;\n        max-width: 62%;\n\n        h2 {\n            font-size: 1.6rem;\n            margin-bottom: 0.75rem;\n        }\n    }\n\n    .login-input {\n        font-size: 1rem;\n        padding: 0.65rem 0.9rem;\n    }\n\n    /* ==========================\n       CADASTRO MOBILE\n       Logo positioning mirrors the\n       onboarding screen for a seamless\n       transition. Form + heading flow\n       below, horizontally centered.\n       ========================== */\n    .cadastro-main {\n        display: block;\n        padding: 0 1.5rem 2rem 0.5rem;\n    }\n\n    .cadastro-side-section {\n        position: absolute;\n        top: 1rem;\n        right: 1.5rem;\n        width: auto;\n        max-width: none;\n        min-height: 0;\n        padding-top: 0;\n        flex-direction: row;\n        justify-content: flex-end;\n        align-items: flex-end;\n        z-index: 1;\n        pointer-events: none;\n    }\n\n    .cadastro-side-section .convexas-logo {\n        width: auto;\n        height: 38vh;\n        max-height: 22rem;\n    }\n\n    .cadastro-date-bottom {\n        display: none;\n    }\n\n    .cadastro-form-section {\n        margin-top: max(4rem, calc(32vh - 2.5rem));\n        margin-right: 0;\n        margin-bottom: 0;\n        margin-left: 0.65rem;;\n        width: 100%;\n        max-width: 21rem;\n        padding-left: 0;\n        padding-right: 0.5rem;\n        position: relative;\n        z-index: 2;\n        justify-self: start;\n    }\n\n    /* Heading sits beside the Convexas logo.\n       The form-grid that follows is full-width and its\n       top rows overlap the bottom of the logo — form-section\n       has z-index 2 so inputs render above the logo. */\n    .cadastro-heading {\n        max-width: 55%;\n        margin-bottom: 0.6rem;\n    }\n\n    .cadastro-label-heading {\n        font-size: 1.4rem;\n    }\n\n    .cadastro-event-title {\n        font-size: 1.8rem;\n    }\n\n    .cadastro-event-subtitle {\n        font-size: 1.55rem;\n    }\n\n    /* Mobile form: 12-col grid with explicit placement + order */\n    .cadastro-form-grid {\n        display: grid;\n        grid-template-columns: repeat(12, 1fr);\n        gap: 0.55rem 0.8rem;\n    }\n\n    /* Full-width rows */\n    .cadastro-form-grid .field-nome,\n    .cadastro-form-grid .field-email,\n    .cadastro-form-grid .field-endereco {\n        grid-column: 1 / -1;\n        max-width: none;\n    }\n\n    /* Número + Complemento: narrower left block */\n    .cadastro-form-grid .field-numero-complemento {\n        grid-column: 1 / 9;\n        max-width: none;\n    }\n\n    .field-inline {\n        .field-numero {\n            flex: 0 0 38%;\n        }\n        .field-complemento {\n            flex: 0 0 52%;\n        }\n    }\n\n    /* Cidade narrow, Estado wider, side-by-side */\n    .cadastro-form-grid .field-cidade {\n        grid-column: 1 / 6;\n    }\n\n    .cadastro-form-grid .field-estado {\n        grid-column: 6 / 12;\n    }\n\n    /* CEP narrow, left only */\n    .cadastro-form-grid .field-cep {\n        grid-column: 1 / 6;\n        max-width: none;\n    }\n\n    /* Telefone + Formação pushed to bottom, narrow */\n    .cadastro-form-grid .field-telefone {\n        grid-column: 1 / 6;\n        order: 10;\n    }\n\n    .cadastro-form-grid .field-formacao {\n        grid-column: 1 / 8;\n        order: 11;\n    }\n\n    .cadastro-submit-row {\n        grid-column: 1 / -1;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n        margin-top: 0.5rem;\n        order: 20;\n    }\n\n    .btn-enviar {\n        align-self: flex-start;\n        padding: 0.85rem 1.8rem;\n    }\n\n    .lgpd-text {\n        max-width: none;\n        font-size: 0.75rem;\n    }\n\n    /* ---- Live ---- */\n    .live-main {\n        padding: 0.5rem 1rem 2rem;\n    }\n\n    .live-with-questions {\n        flex-direction: column;\n    }\n\n    .live-video-wrap {\n        width: 100%;\n    }\n\n    .live-sidebar {\n        flex: none;\n        width: 100%;\n    }\n\n    /* ---- Agenda ---- */\n    .agenda-main {\n        display: block;\n        padding: 0 1.5rem 3rem;\n    }\n\n    .agenda-logo-right {\n        position: absolute;\n        top: 1rem;\n        right: 1.5rem;\n        z-index: 1;\n    }\n\n    .agenda-logo-right .convexas-logo {\n        width: auto;\n        height: 32vh;\n        max-height: 18rem;\n    }\n\n    .agenda-content {\n        margin: calc(32vh + 1.5rem) 0 0;\n        max-width: none;\n    }\n\n    .agenda-item {\n        grid-template-columns: 5rem 1fr;\n        gap: 0 1rem;\n    }\n\n    .bio-modal {\n        padding: 1rem;\n        align-items: flex-end;\n    }\n\n    .bio-modal-content {\n        padding: 2rem 1.25rem 1.5rem;\n        max-height: 90vh;\n    }\n}\n\n/* ==============================\n   RESPONSIVE — small mobile (<480px)\n   ============================== */\n@media (max-width: 480px) {\n    .iac-logo {\n        height: 28px;\n    }\n\n    .login-card {\n        max-width: 70%;\n    }\n\n    .home-content {\n        margin-top: 40vh;\n        max-width: 20rem;\n    }\n\n    .cadastro-heading {\n        max-width: 60%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
